import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import manifestSvg from '../../assets/FINALDARKLOGO.svg';
import Sidebanner from './sidebanner';
import { useAuth } from '../../context/AuthContext';
import supabase from '../../supabase';
import infoSvg from '../../assets/infosvg.svg'
import { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import '../../app.css'



const Star = ({ snapped = 5, size = 33, starWidth = 18 }) => {
  const getStarColor = (val) => {
    const gradients = {
      1: 'linear-gradient(to bottom, #F44141 0%, #AE2525 50%, #720606 100%)',
      1.5: 'linear-gradient(to bottom, #DB5948 0%, #AB4731 50%, #943925 100%)',
      2: 'linear-gradient(to bottom, #DD7447 0%, #AC733D 50%, #673915 100%)',
      2.5: 'linear-gradient(to bottom, #D5D06F 0%, #BCA549 50%, #7E7429 100%)',
      3: 'linear-gradient(to bottom, #9AD25B 0%, #9AD25B 50%, #9BC945 100%)',
      3.5: 'linear-gradient(to bottom, #85CB4F 0%, #57CF4E 50%, #3A7215 100%)',
      4: 'linear-gradient(to bottom, #42BC85 0%, #279267 50%, #146C4C 100%)',
      4.5: 'linear-gradient(to bottom, #50A091 0%, #5A9E91 50%, #2C7A6C 100%)',
      5: 'linear-gradient(to bottom, #3EBAA2 0%, #1E7D6B 50%, #0E6C5B 100%)'
    };
    return gradients[val] || '#d9d9d9';
  };
  const activeGradient = getStarColor(snapped);
  return (
    <div style={{ display: 'flex', gap: '3px' }}>
      {[1, 2, 3, 4, 5].map((i) => {
        let background = (i <= Math.floor(snapped)) ? activeGradient : (i === Math.ceil(snapped) && snapped % 1 !== 0) ? `linear-gradient(90deg, transparent 50%, #d9d9d9 50%), ${activeGradient}` : '#d9d9d9';
        return (
          <div key={i} style={{ width: `${size}px`, height: `${size}px`, background: background, borderRadius: '50%', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
            <div style={{ width: `${starWidth}px`, height: `${starWidth}px`, backgroundColor: 'white', maskImage: 'url(https://sitemanifest.com/static/media/newStar.1214abd603fa433665ca0a5a79d302e7.svg)', maskRepeat: 'no-repeat', maskPosition: 'center', maskSize: 'contain', WebkitMaskImage: 'url(https://sitemanifest.com/static/media/newStar.1214abd603fa433665ca0a5a79d302e7.svg)', WebkitMaskRepeat: 'no-repeat', WebkitMaskPosition: 'center', WebkitMaskSize: 'contain' }} />
          </div>
        );
      })}
    </div>
  );
};

const Step = ({ num, title, desc }) => (
  <div className="flex gap-6 items-start group">
    <span className="text-3xl font-black italic text-gray-100 group-hover:text-indigo-600 transition-colors" style={{ fontFamily: 'Staatliches' }}>{num}</span>
    <div className="text-left">
      <h5 className="text-[13px] font-bold text-black mb-1 uppercase tracking-tight">{title}</h5>
      <p className="text-[12px] text-gray-400 leading-relaxed font-medium">{desc}</p>
    </div>
  </div>
);

export default function Widgetpage() {
  const { business, setBusiness } = useAuth();
  const [isMaximized, setIsMaximized] = useState(false);
  // States
  const [layout, setLayout] = useState('carousel');
  const [isDark, setIsDark] = useState(false);
  const [isTransparent, setIsTransparent] = useState(false);
  const [previewBg, setPreviewBg] = useState('#F9F9FB');
  const [showBorder, setShowBorder] = useState(false);
  const [showShadow, setShowShadow] = useState(false);
  const [scale, setScale] = useState(1.0);
  const [align, setAlign] = useState('center'); 
  const [isDesktop, setIsDesktop] = useState(true);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [showCodeModal, setShowCodeModal] = useState(false); 
  const [activeTab, setActiveTab] = useState('HTML');
  const [scrollPct, setScrollPct] = useState(0);

  const [btnBg, setBtnBg] = useState('#000000');
  const [btnColor, setBtnColor] = useState('#FFFFFF');
  const [btnSize, setBtnSize] = useState(46);

  const [domainInput, setDomainInput] = useState('');

  // Domain Config
  const primaryDomain = business?.www || 'yourdomain.com';
  const additionalDomains = business?.allowed_domains || [];

  const updateBusinessInDB = async (updates) => {
    if (!business?.id) return;
    try {
      const { data, error } = await supabase
        .from('businesses')
        .update(updates)
        .eq('id', business.id)
        .select()
        .single();
      if (error) throw error;
      setBusiness(data);
    } catch (err) {
      console.error("Studio Update Error:", err.message);
    }
  };

  const handleAddDomain = () => {
    let cleanDomain = domainInput
      .toLowerCase()
      .trim()
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .split(/[/?#]/)[0];

    if (
      cleanDomain && 
      cleanDomain !== primaryDomain && 
      !additionalDomains.includes(cleanDomain) && 
      (1 + additionalDomains.length) < 3
    ) {
      const updated = [...additionalDomains, cleanDomain];
      updateBusinessInDB({ allowed_domains: updated });
      setDomainInput('');
    }
  };

  const handleRemoveDomain = (domainToRemove) => {
    const updated = additionalDomains.filter(d => d !== domainToRemove);
    updateBusinessInDB({ allowed_domains: updated });
  };

  const viewportRef = useRef(null);
const visualScale = layout.includes('banner') ? scale * 1.2 : scale * 0.8;

  const reviews = [
    { author: "Marcus Aurelius", title: "Unrivaled Integrity", text: "The forensic tracking is a masterpiece. Finally, a trust system that actually means something." },
    { author: "Elena Fisher", title: "Perfect Integration", text: "Stunning aesthetics. The way it adapts to our brand's dark mode while maintaining speed is incredible." },
    { author: "Julian Vane", title: "High Performance", text: "Zero bloat. Total transparency. This is how reviews should have been handled from the beginning." },
    { author: "Sophia Loren", title: "Simply Beautiful", text: "The design is so clean. It fits perfectly into our luxury brand aesthetic without looking like a plugin." }
  ];

  const colors = {
    bg: isDark ? '#1A1A1A' : '#FFFFFF',
    text: isDark ? '#FFFFFF' : '#323232',
    border: showBorder ? (isDark ? '#2A2A2A' : '#d9d9d9') : 'transparent',
    shadow: showShadow ? (isDark ? '0 15px 45px rgba(0,0,0,0.6)' : '0 10px 30px rgba(0,0,0,0.08)') : 'none',
    line: isDark ? '#2A2A2A' : '#F3F4F6',
  };

  const generateSnippet = () => {
    const themeValue = isTransparent ? (isDark ? 'dark-transparent' : 'light-transparent') : (isDark ? 'dark' : 'light');
    const primaryId = business?.www || "";
    
    return `<script src="https://sitemanifest.com/sitemanifest.js" async></script>
<sitemanifest-widget 
  domain="${primaryId}"
  layout="${layout}"
  theme="${themeValue}"
  scale="${scale.toFixed(1)}"
  shadow="${showShadow}"
  border="${showBorder}"
  nav-bg="${btnBg}"
  nav-color="${btnColor}"
  nav-size="${btnSize}"
  ${layout.includes('banner') ? `align="${align}"` : ''}
></sitemanifest-widget>`;
  };

  const handleScroll = () => {
    if (viewportRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = viewportRef.current;
      const max = scrollWidth - clientWidth;
      setScrollPct(max > 0 ? scrollLeft / max : 0);
    }
  };

  const scroll = (dir) => {
    if (viewportRef.current) {
      const amount = 370; 
      viewportRef.current.scrollBy({ left: dir === 'next' ? amount : -amount, behavior: 'smooth' });
    }
  };
  

  const [messages, setMessages] = useState([
  { role: 'assistant', content: "Sitemanifest AI here. How's the integration going?" }
]);
const [loading, setLoading] = useState(false);

const askEngineer = async (userPrompt) => {
  setLoading(true);
  
  // 1. Update UI with user message immediately
  const newUserMsg = { role: 'user', content: userPrompt };
  setMessages(prev => [...prev, newUserMsg]);

  try {
    // 2. Call the Edge Function
    const { data, error } = await supabase.functions.invoke('sitemanifest-ai', {
      body: { prompt: userPrompt }
    });

    if (error) throw error;

    // 3. Update UI with AI response
    setMessages(prev => [...prev, { role: 'assistant', content: data.text }]);
  } catch (err) {
    console.error("Chat Error:", err.message);
    setMessages(prev => [...prev, { role: 'assistant', content: "Error connecting to engine. Check your console." }]);
  } finally {
    setLoading(false);
  }
};

const scrollRef = useRef(null);

useEffect(() => {
  if (scrollRef.current) {
    scrollRef.current.scrollTo({
      top: scrollRef.current.scrollHeight,
      behavior: 'smooth'
    });
  }
}, [messages]); // Runs every time a new message is added

const inputRef = useRef(null);

// 2. Create the handler function
const handleSendMessage = () => {
  const val = inputRef.current.value.trim();
  if (val && !loading) {
    askEngineer(val);
    inputRef.current.value = ''; // Clear after sending
  }
};

  return (
    <div className="min-h-screen bg-[#F9F9FB] lg:pr-[240px] xl:pr-[240px] 2xl:pr-[340px] pt-[50px] flex flex-col overflow-x-hidden" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Helmet>
        <title>Studio | Sitemanifest</title>
        <link href="https://fonts.googleapis.com/css2?family=Staatliches&family=Poppins:wght@400;600;900&display=swap" rel="stylesheet" />
      </Helmet>

      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; } 
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        .gradient-text { background: linear-gradient(135deg, #000 0%, #444 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
      `}</style>

      {!isEditorOpen && (
        <div className="flex-1 flex flex-col items-center justify-center px-6 py-20 animate-in fade-in duration-700">
          <div className="max-w-4xl w-full text-center mb-16">
            <img src={manifestSvg} className="w-16 h-16 mx-auto mb-8 opacity-90" alt="Logo" />
            <h1 className="text-6xl md:text-7xl font-black italic uppercase tracking-tighter gradient-text mb-6" style={{ fontFamily: 'Staatliches' }}>
              Widget Studio
            </h1>
            <p className="text-gray-500 font-medium text-lg max-w-xl mx-auto leading-relaxed">
              Design the ultimate trust portal for your website. Completely customizable, 
              lightweight, and ready for deployment in seconds.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl w-full mb-16">
            {[
              { step: '01', title: 'Customize', desc: 'Adjust layouts, scales, and brand colors to match your aesthetic.' },
              { step: '02', title: 'Generate', desc: 'Create a unique forensic-grade script for your specific domain.' },
              { step: '03', title: 'Embed', desc: 'Paste a single line of code into your site to activate the widget.' }
            ].map((item, idx) => (
              <div key={idx} className="bg-white p-10 rounded-[40px] shadow-sm border border-gray-100 hover:shadow-xl transition-all group hover:-translate-y-2 text-left">
                <span className="text-4xl font-black italic text-[#323232] mb-4 block" style={{ fontFamily: 'Staatliches' }}>{item.step}</span>
                <h3 className="text-xl font-bold mb-3 tracking-tight">{item.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>


          <span className="text-gray-500 text-sm mb-[24px]">Please use desktop to access the Studio.</span>
          <button onClick={() => setIsEditorOpen(true)} className="group relative px-16 py-8 bg-black text-white rounded-full font-black uppercase tracking-[0.2em] text-[11px] shadow-[0_20px_50px_rgba(0,0,0,0.2)] transition-all hover:scale-105 active:scale-95 overflow-hidden">
            <span className="relative z-10">Enter the Studio</span>
            <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-emerald-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </button>
        </div>
      )}

      {isEditorOpen && (
        <div className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-3xl flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-[1550px] h-[92vh] rounded-[50px] flex flex-col overflow-hidden shadow-md relative">
            
            {/* Header */}
            <div className="flex justify-between items-center px-12 py-8 border-b border-gray-100">
                <div className="flex items-center gap-8">
                  <h2 className="text-3xl font-black italic uppercase tracking-tighter" style={{ fontFamily: 'Staatliches' }}>Sitemanifest Studio</h2>
                  <div className="flex bg-gray-100 p-1 rounded-full">
                      {['carousel', 'banner', 'banner_v2'].map(l => (
                        <button key={l} onClick={() => setLayout(l)} className={`px-6 py-2 rounded-full text-[10px] font-black uppercase transition-all ${layout === l ? 'bg-black text-white' : 'text-gray-400'}`}>{l.replace('_', ' ')}</button>
                      ))}
                  </div>
                </div>
                <button onClick={() => setIsEditorOpen(false)} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-black hover:text-white transition-all text-sm">✕</button>
            </div>

            <div className="flex flex-1 overflow-hidden">
              {/* Preview Area */}
              <div className="flex-1 flex flex-col relative overflow-hidden transition-colors duration-500" style={{ backgroundColor: previewBg }}>
                <div className="flex self-center gap-2 p-1.5 bg-white rounded-full shadow-sm border border-gray-100 mt-12 mb-8 z-10">
                  <button onClick={() => setIsDesktop(true)} className={`px-8 py-2 rounded-full text-[10px] font-black uppercase transition-all ${isDesktop ? 'bg-black text-white' : 'text-gray-400'}`}>Desktop View</button>
                  <button onClick={() => setIsDesktop(false)} className={`px-8 py-2 rounded-full text-[10px] font-black uppercase transition-all ${!isDesktop ? 'bg-black text-white' : 'text-gray-400'}`}>Mobile View</button>
                </div>

                <div className="w-full flex-1  flex items-center justify-center px-12">
                  <div  style={{ width: '100%', display: 'flex', justifyContent: layout === 'carousel' ? 'center' : (align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center') }}>
                    <div style={{ transform: `scale(${visualScale})`, transformOrigin: layout === 'carousel' ? 'center' : (align === 'left' ? 'center left' : align === 'right' ? 'center right' : 'center'), transition: 'all 0.5s cubic-bezier(0.2, 1, 0.3, 1)' }} className="flex justify-center">
                      
                      {layout === 'carousel' && (
                        <div style={{ width: isDesktop ? '1090px' : '350px' }} className="flex  flex-col items-center">
                          <div ref={viewportRef} onScroll={handleScroll} className="flex gap-5  overflow-x-auto snap-x snap-mandatory no-scrollbar w-full  py-16 scroll-smooth">
                            <div style={{ width: '350px', height: '220px', padding: '24px', borderRadius: '24px', flexShrink: 0, background: colors.bg, color: colors.text, border: `1px solid ${colors.border}`, boxShadow: colors.shadow, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', snapAlign: 'start' }}>
                              <span className="text-2xl font-semibold">Great</span>
                              <div className="my-3 flex gap-2"><Star snapped={5} /></div>
                              <span className={`text-[12px] opacity-60 tracking-wider text-center`}>4.9 Based on 250 Verified Reviews</span>
                              <div style={{ marginTop: 'auto', paddingTop: '16px', borderTop: `1px solid ${colors.line}`, display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'center' }}>
                                <img className="w-[24px]" src={manifestSvg} style={{ filter: isDark ? 'invert(1) brightness(2)' : 'none' }} alt="SM" />
                                <span className="mt-[3px]" style={{ fontFamily: 'Staatliches', fontSize: '18px', letterSpacing: '3px' }}>SITEMANIFEST</span>
                              </div>
                            </div>
                            {reviews.map((r, i) => (
                              <div key={i} style={{ width: '350px', height: '220px', padding: '24px', borderRadius: '24px', flexShrink: 0, background: colors.bg, color: colors.text, border: `1px solid ${colors.border}`, boxShadow: colors.shadow, display: 'flex', flexDirection: 'column', snapAlign: 'start' }}>
                                <div className="flex justify-between mb-2">
                                  <span className="font-medium text-[14px]">{r.author}</span>
                                  <span className={`text-[10px] opacity-50`}>3/23/2026</span>
                                </div>
                                <div className="mb-4"><Star snapped={5} size={22} starWidth={11} /></div>
                                <h6 className="font-semibold text-sm mb-1">{r.title}</h6>
                                <p className="text-[13px] opacity-60 line-clamp-3 leading-relaxed font-medium">{r.text}</p>
                              </div>
                            ))}
                          </div>
                          <div className="flex items-center gap-6 mt-4">
                            <button onClick={() => scroll('prev')} style={{ backgroundColor: btnBg, color: btnColor, width: `${btnSize}px`, height: `${btnSize}px` }} className="rounded-full  flex items-center justify-center transition-all shadow-md active:scale-90 hover:scale-110">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
                            </button>
                            <div className={`w-36 h-2 rounded-full overflow-hidden relative ${isDark ? 'bg-white/10' : 'bg-black/10'}`}>
                              <div style={{ position: 'absolute', width: '33%', height: '100%', background: '#08696D', transform: `translateX(${scrollPct * 200}%)`, transition: 'transform 0.3s' }} />
                            </div>
                            <button onClick={() => scroll('next')} style={{ backgroundColor: btnBg, color: btnColor, width: `${btnSize}px`, height: `${btnSize}px` }} className="rounded-full  flex items-center justify-center transition-all shadow-md active:scale-90 hover:scale-110">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                            </button>
                          </div>
                        </div>
                      )}
{(layout === 'banner' || layout === 'banner_v2') && (
  <div style={{ 
    minWidth: layout === 'banner' ? '340px' : '280px', 
    height: '70px', 
    padding: '0 24px', 
    borderRadius: '12px', 
    background: isTransparent ? 'transparent' : colors.bg, 
    color: colors.text, 
    border: `1px solid ${colors.border}`, 
    boxShadow: colors.shadow, 
    display: 'flex', 
    flexDirection: layout === 'banner' ? 'row' : 'column', 
    alignItems: layout === 'banner' ? 'center' : 'flex-start', 
    // Increased gap from 'center' to add internal breathing room for V2
    justifyContent: layout === 'banner' ? 'space-between' : 'center',
    gap: layout === 'banner_v2' ? '2px' : '0px' 
  }}>
      <div className="flex flex-col gap-[4px]">
        <div className='flex gap-[12px] flex-row items-center'>
          <img className="w-[20px]" src={manifestSvg} style={{ filter: isDark ? 'invert(1) brightness(2)' : 'none' }} alt="SM" />
          <span style={{ fontFamily: 'Staatliches', fontSize: '18px', letterSpacing: '2px' }}>SITEMANIFEST</span>
        </div>
        {layout === 'banner' && <span className="text-[9px] tracking-widest text-left">4.9 Based on 250 Reviews</span>}
      </div>
      
      <div 
        style={{ zoom: layout === 'banner' ? 0.6 : 0.55 }} 
        className={`flex items-center gap-3 ${layout === 'banner_v2' ? 'mt-[6px]' : ''}`}
      >
        <Star snapped={5} />
        {layout === 'banner_v2' && (
          <div className='flex gap-[12px] mt-[4px] flex-row items-center'>
            <span className={`text-[18px] tracking-[1px]`}>4.9</span>
            <div className={`w-[4.2px] h-[4.2px] ${isDark ? 'bg-white' : 'bg-[#323232]'} rounded-full`}></div>
            <span className={`text-[18px] tracking-[1px]`}>250 Reviews</span>
          </div>
        )}
      </div>
  </div>
)}

                    </div>
                  </div>
                </div>
              </div>

              {/* Sidebar */}
              <div className="w-[400px] bg-white border-l border-gray-100 p-12 flex flex-col gap-10 text-left overflow-y-auto no-scrollbar">
                
                {/* 1. Preview Environment (RGB Control) */}
                <section className="space-y-4">
                  <div className="flex justify-between items-center mb-2">
                    <label className="text-[10px] font-black uppercase tracking-[4px] text-gray-300">Background Preview</label>
                    <div className="flex gap-1 bg-gray-100 p-1 rounded-lg">
                       {['#F9F9FB', '#FFFFFF', '#111111'].map(c => (
                         <button 
                           key={c}
                           onClick={() => setPreviewBg(c)}
                           className={`w-4 h-4 rounded-full border border-white shadow-sm transition-all ${previewBg === c ? 'scale-125 border-black' : 'hover:scale-110'}`}
                           style={{ backgroundColor: c }}
                         />
                       ))}
                    </div>
                  </div>

                  <div className="p-6 rounded-[28px] border border-gray-100 bg-gray-50/50 flex items-center justify-between">
                    <div className="flex flex-col">
                      <span className="text-[9px] font-bold text-gray-400 uppercase mb-1">Custom HEX</span>
                      <span className="text-[12px] font-black font-mono uppercase tracking-tighter">{previewBg}</span>
                    </div>
                    <div className="relative group">
                      <input 
                        type="color" 
                        value={previewBg.startsWith('#') ? previewBg : '#F9F9FB'} 
                        onChange={(e) => setPreviewBg(e.target.value)} 
                        className="w-12 h-12 rounded-2xl cursor-pointer bg-white border-2 border-white shadow-sm appearance-none overflow-hidden [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:border-none" 
                      />
                    </div>
                  </div>
                </section>

                {/* 2. Visual Scale */}
                <section>
                  <div className="flex justify-between items-center mb-6">
                    <label className="text-[10px] font-black uppercase tracking-[4px] text-indigo-500">Visual Scale</label>
                    <span className="text-[12px] font-black font-mono bg-black text-white px-3 py-1 rounded-lg">{scale.toFixed(1)}</span>
                  </div>
                  <input type="range" min="0.5" max="1.5" step="0.1" value={scale} onChange={(e) => setScale(parseFloat(e.target.value))} className="w-full h-1.5 bg-gray-100 rounded-lg appearance-none cursor-pointer accent-black" />
                </section>
                
                {/* 3. Navigation Style */}
                <section className={`${layout === "carousel" ? "" : "hidden"} space-y-4`}>
                  <label className="text-[10px] font-black uppercase tracking-[4px] text-gray-300 block mb-2">Navigation Style</label>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="p-4 rounded-3xl border border-gray-100 bg-gray-50/50">
                        <span className="text-[9px] font-bold text-gray-400 block mb-2 uppercase">Background</span>
                        <div className="flex items-center gap-2">
                            <input type="color" value={btnBg} onChange={(e) => setBtnBg(e.target.value)} className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none" />
                            <span className="text-[10px] font-mono font-bold uppercase">{btnBg}</span>
                        </div>
                    </div>
                    <div className="p-4 rounded-3xl border border-gray-100 bg-gray-50/50">
                        <span className="text-[9px] font-bold text-gray-400 block mb-2 uppercase">Arrow</span>
                        <div className="flex items-center gap-2">
                            <input type="color" value={btnColor} onChange={(e) => setBtnColor(e.target.value)} className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none" />
                            <span className="text-[10px] font-mono font-bold uppercase">{btnColor}</span>
                        </div>
                    </div>
                  </div>

                  {/* Button Size Control */}
<div className="col-span-2 p-4 rounded-3xl border border-gray-100 bg-gray-50/50">
    <div className="flex justify-between items-center mb-3">
        <span className="text-[9px] font-bold text-gray-400 uppercase">Button Size</span>
        <span className="text-[10px] font-mono font-bold bg-white px-2 py-1 rounded-lg border border-gray-100">{btnSize}px</span>
    </div>
    <input 
        type="range" 
        min="32" 
        max="64" 
        value={btnSize} 
        onChange={(e) => setBtnSize(parseInt(e.target.value))} 
        className="w-full h-1.5 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-black"
    />
    <div className="flex justify-between mt-1 text-[8px] font-bold text-gray-300 uppercase tracking-wider">
        <span>Small</span>
        <span>Large</span>
    </div>
</div>
                </section>

                {/* 4. Authorized Domains */}
                <section className="space-y-4">
                  <div className="flex justify-between items-center">
                    <div className='flex flex-row items-center gap-[4px]'>
                      <label className="text-[10px] font-black uppercase tracking-[4px] text-indigo-500">Authorized Domains</label>
                      <img className='cursor-pointer' src={infoSvg} alt="Info" />
                    </div>
                    <span className="text-[10px] font-bold text-gray-400">{1 + additionalDomains.length}/3</span>
                  </div>
                  
                  <div className="p-6 rounded-[28px] border border-gray-100 bg-gray-50/50 space-y-4 text-left">
                    <div className="flex flex-wrap gap-2">
                      <div className="flex items-center gap-2 bg-indigo-600 text-white px-3 py-1.5 rounded-full text-[10px] font-bold shadow-sm">
                        <span className="opacity-70">●</span>
                        <span>{primaryDomain}</span>
                      </div>

                      {additionalDomains.map((domain, index) => (
                        <div key={index} className="flex items-center gap-2 bg-black text-white px-3 py-1.5 rounded-full text-[10px] font-bold animate-in zoom-in duration-200">
                          <span>{domain}</span>
                          <button onClick={() => handleRemoveDomain(domain)} className="hover:text-red-400 ml-1">✕</button>
                        </div>
                      ))}
                    </div>

                    {(1 + additionalDomains.length) < 3 ? (
                      <div className="flex gap-2">
                        <input 
                          type="text" 
                          placeholder="additional-site.com"
                          value={domainInput}
                          onChange={(e) => setDomainInput(e.target.value.toLowerCase().replace(/\s+/g, ''))}
                          onKeyDown={(e) => { if(e.key === 'Enter') handleAddDomain(); }}
                          className="flex-1 bg-white border border-gray-200 rounded-xl px-4 py-2 text-[12px] font-medium outline-none focus:border-black transition-all"
                        />
                        <button onClick={handleAddDomain} className="bg-black text-white px-4 rounded-xl text-[11px] font-black uppercase hover:bg-indigo-600">ADD</button>
                      </div>
                    ) : (
                      <p className="text-[10px] text-gray-400 italic">Security limit reached (3 domains max).</p>
                    )}
                  </div>
                </section>

                {/* 5. Toggles */}
{/* ALIGNMENT SELECTOR - Ultra-Lean Version */}
{layout.includes('banner') && (
  <div className="px-5 py-4 rounded-[24px] border-2 border bg-gray-50 shadow-sm flex flex-col gap-2 transition-all">
    <div className="flex justify-between items-center">
      <span className="text-[9px] font-black uppercase tracking-widest text-black">Alignment</span>
    </div>
    
    <div className="flex bg-gray-200/50 p-1 rounded-xl w-full">
      {['left', 'center', 'right'].map((a) => (
        <button
          key={a}
          onClick={() => setAlign(a)}
          className={`flex-1 py-1.5 rounded-lg text-[8px] font-black uppercase transition-all ${
            align === a 
              ? 'bg-black text-white shadow-md' 
              : 'text-gray-400 hover:text-black'
          }`}
        >
          {a}
        </button>
      ))}
    </div>
  </div>
)}

{/* MODIFIED TOGGLE LIST - Matching the lean style */}
<div className="grid grid-cols-1 gap-2">
  {[
    { label: 'Dark Mode', state: isDark, set: setIsDark },
    ...(layout.includes('banner') ? [{ label: 'Transparent', state: isTransparent, set: setIsTransparent }] : []),
    { label: 'Border', state: showBorder, set: setShowBorder },
    { label: 'Shadow', state: showShadow, set: setShowShadow }
  ].map((item, idx) => (
    <div 
      key={idx} 
      onClick={() => item.set(!item.state)} 
      className={`px-5 py-3 rounded-[20px] border-2 cursor-pointer flex justify-between items-center transition-all ${
        item.state ? 'bg-gray-50 border-black' : 'bg-white border-gray-100 text-gray-400'
      }`}
    >
      <span className={`text-[9px] font-black uppercase tracking-widest ${item.state ? 'text-black' : ''}`}>
        {item.label}
      </span>
      <div className={`w-7 h-4 rounded-full relative transition-colors ${item.state ? 'bg-black' : 'bg-gray-200'}`}>
        <div className={`absolute top-0.5 w-3 h-3 bg-white rounded-full transition-all ${item.state ? 'left-3.5' : 'left-0.5'}`} />
      </div>
    </div>
  ))}
</div>
                <button onClick={() => setShowCodeModal(true)} className="mt-auto py-8 bg-black text-white rounded-[40px] font-black uppercase tracking-[6px] text-[10px] shadow-2xl hover:scale-105 active:scale-95 transition-all">Copy Embed Script</button>
              </div>
            </div>

            {/* Code Modal */}
         {showCodeModal && (
  <div className="fixed inset-0 z-[120] bg-white/95 backdrop-blur-xl flex items-center justify-center p-0 md:p-12 overflow-hidden">
    <div className={`w-full transition-all duration-500 ease-in-out bg-white ${isMaximized ? 'h-full w-full rounded-none' : 'h-[90vh] max-w-7xl rounded-[40px] md:rounded-[60px]'} p-6 md:p-12 border border-gray-100 shadow-2xl relative flex flex-col overflow-hidden`}>
      
      {/* Top Controls - Sticky and Minimal */}
      <div className="absolute top-6 right-6 flex gap-3 z-50">
        <button 
          onClick={() => setIsMaximized(!isMaximized)} 
          className="w-10 h-10 bg-gray-100/50 backdrop-blur-md rounded-full flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all shadow-sm border border-gray-200"
        >
          {isMaximized ? (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M4 14h6v6M20 10h-6V4M14 10l7-7M10 14l-7 7"/></svg>
          ) : (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>
          )}
        </button>

        <button 
          onClick={() => setShowCodeModal(false)} 
          className="w-10 h-10 bg-gray-100/50 backdrop-blur-md rounded-full flex items-center justify-center hover:bg-black hover:text-white transition-all shadow-sm border border-gray-200"
        >
          ✕
        </button>
      </div>

      {/* Content Grid */}
      <div className={`grid gap-8 flex-1 min-h-0 transition-all duration-500 ${isMaximized ? 'grid-cols-1' : 'grid-cols-1 lg:grid-cols-2'}`}>
        
        {/* LEFT COLUMN (Snippet) - Only shows when NOT Maximized */}
        {!isMaximized && (
          <div className="flex flex-col space-y-6 overflow-y-auto no-scrollbar pr-2 animate-in fade-in slide-in-from-left-4 duration-500">
             <h3 className="text-2xl font-black uppercase italic tracking-tighter" style={{ fontFamily: 'Staatliches' }}>Integration</h3>
        
            <div className="bg-gray-900 rounded-[30px] p-6 relative border-[4px] border-gray-800 shadow-md">
              <pre className="text-emerald-400 font-mono text-[10px] leading-relaxed overflow-x-auto no-scrollbar text-left whitespace-pre-wrap">{generateSnippet()}</pre>
              <button onClick={() => { navigator.clipboard.writeText(generateSnippet()); alert("Copied!"); }} className="mt-4 w-full py-3 bg-white text-black rounded-xl text-[9px] font-black uppercase hover:bg-emerald-400 transition-all">Copy Script</button>
            </div>

            <div className="space-y-3">
              {activeTab === 'HTML' && <><Step num="01" title="Header" desc="Paste in <head>." /><Step num="02" title="Body" desc="Drop widget tag." /></>}
              {activeTab === 'React' && <><Step num="01" title="Client" desc="Use 'use client'." /><Step num="02" title="Effect" desc="Load in useEffect." /></>}
            </div>
          </div>
        )}

        {/* RIGHT COLUMN: THE MESSAGING FIELD (The "Everything" Field) */}
        <div className={`flex flex-col bg-gray-50 transition-all duration-500 overflow-hidden h-full ${isMaximized ? 'p-0 bg-white' : 'rounded-[40px] p-6 border border-gray-100 shadow-inner'}`}>
          
          {/* Internal Label - Minimal */}
          <div className={`flex items-center gap-2 mb-4 flex-shrink-0 ${isMaximized ? 'mt-4 ml-4' : ''}`}>
             <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
             <p className="text-[9px] font-black text-gray-400 uppercase tracking-[3px]">Sitemanifest AI Live</p>
          </div>

          {/* Messages Window - Expands to fill every bit of space */}
        {/* Messages Window */}
<div 
  ref={scrollRef} 
  className={`flex-1 overflow-y-auto no-scrollbar space-y-6 p-4 scroll-smooth ${isMaximized ? 'max-w-4xl mx-auto w-full' : ''}`}
>
  {messages.map((msg, i) => (
    <div key={i} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'} animate-in fade-in slide-in-from-bottom-2 duration-300`}>
      <div className={`max-w-[90%] p-6 rounded-[32px] shadow-sm border transition-all ${msg.role === 'user' ? 'bg-black text-white rounded-tr-none' : 'bg-white text-black rounded-tl-none border-gray-200'}`}>
        <div className={`prose prose-sm max-w-none text-[13px] leading-relaxed ${msg.role === 'user' ? 'prose-invert text-white' : 'text-slate-800'}`}>
          <ReactMarkdown>{msg.content}</ReactMarkdown>
        </div>
      </div>
    </div>
  ))}

  {/* THE "RINGING" INDICATOR */}
  {loading && (
    <div className="flex justify-start animate-in fade-in slide-in-from-left-2 duration-300">
      <div className="bg-white border border-gray-100 p-6 rounded-[32px] rounded-tl-none shadow-sm flex flex-col gap-3">
        <span className="text-[7px] font-black uppercase tracking-[2px] text-indigo-600 animate-pulse">
          thinking...
        </span>
        <div className="flex gap-1.5">
          <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce [animation-duration:0.8s]" />
          <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce [animation-duration:0.8s] [animation-delay:0.2s]" />
          <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce [animation-duration:0.8s] [animation-delay:0.4s]" />
        </div>
      </div>
    </div>
  )}
</div>

          {/* Input Box - Glued to the bottom */}
          <div className={`flex-shrink-0 p-6 ${isMaximized ? 'max-w-4xl mx-auto w-full mb-4' : 'mt-auto'}`}>
            <div className="relative">
              <input 
              ref={inputRef}
                type="text" 
                placeholder="Message Lead Engineer..."
                className="w-full bg-white border-2 border-gray-200 rounded-[24px] py-5 px-8 text-[13px] font-bold outline-none focus:border-indigo-600 transition-all pr-16 shadow-xl"
               onKeyDown={(e) => {
      if (e.key === 'Enter') {
        handleSendMessage();
      }
    }}
              />
              <button onClick={handleSendMessage} className="absolute right-3 top-2 w-12 h-12 bg-indigo-600 text-white rounded-2xl flex items-center justify-center hover:bg-black transition-all shadow-md">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
)}
          </div>
        </div>
      )}
      <Sidebanner />
    </div>
  );
}